import { useMemo } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Button } from "../components/ui/button";

export default function CatalogFilters({
  filters, vehicle, series, variant_type, rarity,
  chase_only, blkltd_only, sort, onFilterChange,
}) {
  // Memoize cleaned dropdown lists so we don't re-filter on every keystroke /
  // unrelated parent re-render. Source of truth is `filters` from the API.
  const vehicles = useMemo(() => (filters?.vehicles || []).filter(Boolean), [filters?.vehicles]);
  const seriesOptions = useMemo(() => (filters?.series || []).filter(Boolean), [filters?.series]);
  const variantTypes = useMemo(() => (filters?.variant_types || []).filter(Boolean), [filters?.variant_types]);
  const rarities = useMemo(() => (filters?.rarities || []).filter(Boolean), [filters?.rarities]);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
      <Select value={vehicle || "all"} onValueChange={(v) => onFilterChange("vehicle", v === "all" ? "" : v)}>
        <SelectTrigger className="bg-zinc-950 border-zinc-800 text-zinc-300 text-xs"><SelectValue placeholder="Vehicle" /></SelectTrigger>
        <SelectContent className="bg-zinc-900 border-zinc-800">
          <SelectItem value="all">All Vehicles</SelectItem>
          {vehicles.map((v) => <SelectItem key={v} value={v}>{v}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={series || "all"} onValueChange={(v) => onFilterChange("series", v === "all" ? "" : v)}>
        <SelectTrigger className="bg-zinc-950 border-zinc-800 text-zinc-300 text-xs"><SelectValue placeholder="Series" /></SelectTrigger>
        <SelectContent className="bg-zinc-900 border-zinc-800">
          <SelectItem value="all">All Series</SelectItem>
          {seriesOptions.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={variant_type || "all"} onValueChange={(v) => onFilterChange("variant_type", v === "all" ? "" : v)}>
        <SelectTrigger className="bg-zinc-950 border-zinc-800 text-zinc-300 text-xs"><SelectValue placeholder="Type" /></SelectTrigger>
        <SelectContent className="bg-zinc-900 border-zinc-800">
          <SelectItem value="all">All Types</SelectItem>
          {variantTypes.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={rarity || "all"} onValueChange={(v) => onFilterChange("rarity", v === "all" ? "" : v)}>
        <SelectTrigger className="bg-zinc-950 border-zinc-800 text-zinc-300 text-xs"><SelectValue placeholder="Rarity" /></SelectTrigger>
        <SelectContent className="bg-zinc-900 border-zinc-800">
          <SelectItem value="all">All Rarities</SelectItem>
          {rarities.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
        </SelectContent>
      </Select>
      <Button
        data-testid="chase-only-toggle"
        variant={chase_only ? "default" : "outline"}
        onClick={() => onFilterChange("chase_only", chase_only ? "" : "true")}
        className={chase_only ? "bg-amber-500 hover:bg-amber-400 text-zinc-950" : "bg-zinc-950 border-zinc-800 text-zinc-400 hover:bg-zinc-800"}
        size="sm"
      >
        Chase Only
      </Button>
      <Button
        data-testid="blkltd-only-toggle"
        variant={blkltd_only ? "default" : "outline"}
        onClick={() => onFilterChange("blkltd_only", blkltd_only ? "" : "true")}
        className={blkltd_only ? "bg-purple-500 hover:bg-purple-400 text-white" : "bg-zinc-950 border-zinc-800 text-zinc-400 hover:bg-zinc-800"}
        size="sm"
      >
        BLKLTD Only
      </Button>
    </div>
  );
}
